module.exports = __webpack_public_path__ + "res/ic_menu_campaigns_t.aa4c074fb09913794a9cc7ab24a3c002.png";